import { Alternative as r } from "./alternative.js";
import { CircleSmallFill as m } from "./circle-small-fill.js";
import { Circle as o } from "./circle.js";
import { CircleSmall as i } from "./circle-small.js";
import { CircleFill as l } from "./circle-fill.js";
import { Diversity as t } from "./diversity.js";
import { Dot as p } from "./dot.js";
import { Square as e } from "./square.js";
import { SquareFill as f } from "./square-fill.js";
import { SquareSmall as a } from "./square-small.js";
import { SquareSmallFill as S } from "./square-small-fill.js";
import { Triangle as c } from "./triangle.js";
import { TriangleFill as n } from "./triangle-fill.js";
import { DotSmall as q } from "./dot-small.js";
import { DotTiny as u } from "./dot-tiny.js";
import { SquareStraight as F } from "./square-straight.js";
const B = {
  Alternative: r,
  CircleSmallFill: m,
  Circle: o,
  CircleSmall: i,
  CircleFill: l,
  Diversity: t,
  Dot: p,
  Square: e,
  SquareFill: f,
  SquareSmall: a,
  SquareSmallFill: S,
  Triangle: c,
  TriangleFill: n,
  DotSmall: q,
  DotTiny: u,
  SquareStraight: F
};
export {
  B as Shapes
};
